import { Alert, Button } from '@mui/material'
import { ApiError, DimNotApplicableError } from '~/api/types'
import { getInlineMessage } from '~/errors/handleApiError'
import { MESSAGES } from '~/components/Charts/chrome/chartChrome'
import { DimNotApplicableNote } from './DimNotApplicableNote'

interface Props {
  error: unknown
  onRetry: () => void
  /** FU-m: name the affected arm in the typed group-by note. */
  metricLabel?: string
}

/** Tile-level walk failure: distinguishes a DB statement timeout (57014) from a
 * generic failure, and always offers a Retry. Distinct from the empty-state.
 * The timeout text is sourced from classifyError (single source of truth). */
export function WalkError({ error, onRetry, metricLabel }: Props) {
  if (error instanceof DimNotApplicableError) {
    return <DimNotApplicableNote dims={error.dims} metricLabel={metricLabel} />
  }
  const isTimeout = error instanceof ApiError && error.envelope.code === '57014'
  const message = (isTimeout && getInlineMessage(error)) || MESSAGES.chartLoadFailed
  return (
    <Alert
      severity={isTimeout ? 'warning' : 'error'}
      action={
        <Button size="small" onClick={onRetry}>
          {MESSAGES.retry}
        </Button>
      }
    >
      {message}
    </Alert>
  )
}
